import type { OpenAPI } from "simplydo/interfaces";

export const getUserDomain = (user: OpenAPI.Schemas["User"]) => {
  if (!user) {
    return;
  }

  if (user.emails.length === 0) {
    return;
  }

  const email = user.emails[0];
  if (!email || !email.verified) {
    return;
  }

  return email.address.split("@")[1];
};

export const isCommonDomain = (domain: string) => {
  const domainParts = domain.split(".");
  if (!domainParts.length) {
    return false;
  }
  const domainProvider = domainParts[0];
  if (!domainProvider) {
    return false;
  }

  if (commonDomainProviders.includes(domainProvider)) {
    return true;
  }

  for (const ending of commonDomainEndings) {
    if (domain.endsWith(ending)) {
      return true;
    }
  }
};

export const commonDomainEndings = [
  ".ac.uk",
  ".edu",
  "nhs.net",
  "cp.catapult.org.uk",
  "digicatapult.org.uk",
  "gov.uk",
  "nhs.uk",
];

export const commonDomainProviders = [
  "gmail",
  "yahoo",
  "outlook",
  "hotmail",
  "aol",
  "icloud",
  "zoho",
  "mail",
  "gmx",
  "protonmail",
  "rocketmail",
  "googlemail",
  "live",
  "rediffmail",
  "rediff",
  "msn",
  "att",
  "sbcglobal",
  "verizon",
  "comcast",
  "charter",
  "optonline",
  "earthlink",
  "cox",
  "frontier",
  "windstream",
  "btinternet",
  "talktalk",
  "sky",
  "virginmedia",
  "blueyonder",
  "ntlworld",
  "tiscali",
  "zen",
  "plus",
  "uk2",
  "web",
  "freenet",
  "t-online",
  "orange",
  "sfr",
  "laposte",
  "libero",
  "virgilio",
  "alice",
  "tin",
  "wanadoo",
  "free",
  "online",
  "ziggo",
  "xs4all",
  "rogers",
  "bell",
  "sympatico",
  "telus",
  "shaw",
  "cogeco",
  "mts",
  "eastlink",
  "sasktel",
  "videotron",
  "bigpond",
  "optusnet",
  "iinet",
  "dodo",
  "internode",
  "tpg",
  "westnet",
  "adam",
  "primus",
  "netspace",
  "qq",
  "163",
  "126",
  "sina",
  "naver",
  "hanmail",
  "daum",
  "yahoo",
  "mail",
  "yandex",
  "uol",
  "terra",
  "bol",
  "oi",
  "speedy",
  "fibertel",
  "arnet",
  "prodigy",
  "telmex",
  "maktoob",
  "arabia",
  "naseej",
  "sawasdee",
  "dubaimail",
  "emarati",
  "mweb",
  "vodamail",
  "webmail",
  "kenyaweb",
  "afrihost",
  "fastmail",
  "hushmail",
  "runbox",
  "tutanota",
  "startmail",
  "yopmail",
  "temp-mail",
  "email",
  "inbox",
];
